// extracted by mini-css-extract-plugin
export default {"tags-expand":"ArticleTags_tags-expand__FgRDL","icon":"ArticleTags_icon__8L4Df","preview-text":"ArticleTags_preview-text__RYZV1"};